import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../../common';
import { translate } from '../../../common/translation/translate';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { DisplayAdWidget } from '../../ads/displayAdWidget.jsx';
import { LocationTitleLoadingUI } from '../hourlyForecast/loadingUI/common/locationTitleLoadingUI';
import { defaultReading } from './utils';
import { DisplayAdUnit } from '../../../containers/ads/displayAdUnitContainer';

interface ForecastSubTabLocationTitleProps {
    routePath: string;
    cityName: string;
    territoryAbbr?: string;
    countryIso3Code: string;
    pageId: string;
    isLoadingHourlyPageView: boolean;
    isMobile?: boolean;
}

const hourlyPageData = {
    pageId: 'forecasts/hourly',
    localizedRoutePath: '/weather-forecast/hourly/:location'
};

const dailyPageData = {
    pageId: 'forecasts/daily',
    localizedRoutePath: '/weather-forecast/10-day-weather/:location'
};

const mapStoreStateToProps = (storeState: any) => {
    const { hourlyForecastPage, appState } =  storeState || {};
    const { hourlyForecastPeriods } = hourlyForecastPage || {};
    const { user, pageId, routePath } = appState?.appState || {};
    const { CityName: cityName, TerritoryAbbr: territoryAbbr, CountryIso3Code: countryIso3Code } = user?.ActiveLocation?.Locality ?? {};

    const isLoadingHourlyPageView = !cityName && !hourlyForecastPeriods?.length;
    return {
        pageId,
        routePath,
        cityName,
        territoryAbbr,
        countryIso3Code,
        isLoadingHourlyPageView 
    };
};

const mapDispatchToProps = {};

export const ForecastSubTabLocationTitle = memo(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ 
    isLoadingHourlyPageView,
    routePath,
    pageId,
    cityName,
    territoryAbbr,
    countryIso3Code, 
    isMobile }: ForecastSubTabLocationTitleProps) => {
    
    if (isLoadingHourlyPageView) {
        return <LocationTitleLoadingUI />;
    }

    let forecastHeaderText = defaultReading;

    if (pageId === hourlyPageData.pageId) {
        forecastHeaderText = translate('hourlyForecast'); // National page
        if (routePath === hourlyPageData.localizedRoutePath && cityName && (territoryAbbr || countryIso3Code)) {
            forecastHeaderText = territoryAbbr ? `${forecastHeaderText} - ${cityName}, ${territoryAbbr}` : `${forecastHeaderText} - ${cityName}, ${countryIso3Code}`; // Localized page
        }
    } else if (pageId === dailyPageData.pageId) {
        forecastHeaderText = translate('tenDayWeather'); // National page
        if (routePath === dailyPageData.localizedRoutePath && cityName && (territoryAbbr || countryIso3Code)) {
            forecastHeaderText = territoryAbbr ? `${forecastHeaderText} - ${cityName}, ${territoryAbbr}` : `${forecastHeaderText} - ${cityName}, ${countryIso3Code}`; // Localized page
        }
    }

    return (
        <HeaderWrapper>
            { isMobile && pageId
                && <AdWrapper>
                    <DisplayAdUnit slotId={`${pageId}_x83`} width={320} height={50}/>
                </AdWrapper>
            }
            <Container>
                {forecastHeaderText}
            </Container>
        </HeaderWrapper>
    );
}));

const HeaderWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;

    @media ${smallMediaQuery} {
        flex-direction: column;
    }
`;

const Container = styled.h1`
    width: 100%;
    height: auto;
    font-family: Source Sans Pro Semibold, sans-serif;
    font-size: 15px;
`;

const AdWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: auto;
`;